'use client';
import { __rest } from 'tslib';
import React from 'react';
import { styled } from '../stitches.config.js';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import { overlayStyles } from './Overlay.js';
import { panelStyles } from './Panel.js';

const AlertDialog = AlertDialogPrimitive.Root;
const AlertDialogTrigger = AlertDialogPrimitive.Trigger;
const StyledOverlay = styled(AlertDialogPrimitive.Overlay, overlayStyles, {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
});
const StyledContent = styled(AlertDialogPrimitive.Content, panelStyles, {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 200,
    maxHeight: '85vh',
    padding: '$4',
    marginTop: '-5vh',
    '&:focus': {
        outline: 'none',
    },
});
const AlertDialogContent = React.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(AlertDialogPrimitive.Portal, null,
        React.createElement(StyledOverlay, null),
        React.createElement(StyledContent, Object.assign({}, props, { ref: forwardedRef }), children)));
});
const AlertDialogTitle = AlertDialogPrimitive.Title;
const AlertDialogDescription = AlertDialogPrimitive.Description;
const AlertDialogAction = AlertDialogPrimitive.Action;
const AlertDialogCancel = AlertDialogPrimitive.Cancel;

export { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogTitle, AlertDialogTrigger, StyledContent };
